import { useRef } from 'react';
import SoundFile from 'assets/message.mp3';

const useNotificationAudio = () => {
  const notificationAudio = new Audio(SoundFile);
  const audioRef = useRef(notificationAudio);

  const play = (loop) => {
    audioRef.current.loop = !!loop;
    audioRef.current.load();
    const promise = audioRef.current.play();
    if (promise) {
      promise.then().catch((error) => {
        console.log(error);
      });
    }
  };

  const pause = () => {
    audioRef.current.loop = false;
    audioRef.current.pause();
  };

  return {
    play,
    pause,
  };
};

export default useNotificationAudio;
